import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr} from '../utils.js'
import UniTable from '../cmp/UniTable.js'
import FilterForm from '../cmp/FilterForm.js' //+
import Menu from '../cmp/menu.js'
import icon from '../icons.svg'

function CatDevicesList({data=undefined,actions,choice=false}){
    const type='catDevices'
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData

    const context=useContext(dataContext)
    const Data=context.data[type]
    const selDeviceType=context.data['selDeviceType']
    const getData=context.getData
    const saveData=context.saveData
    const updateData=context.updateData
    const msg=context.msg
    const addTWnd=context.addTWnd
    const getSettings=context.getSettings
    const setSettings=context.setSettings
    const usersettings=getSettings()
    const inputCols=context.inputCols
    const glStatus=context.status
    
    const cols=[
        {caption:'ico',minWidth:'24',dataId:'prnicon',sortable:false},
        {caption:'id',minWidth:'12',dataId:'id',sortable:true},
        {caption:localestr('Назва'),minWidth:'160',dataId:'name',sortable:true},
        {caption:localestr('Тип пристрою'),minWidth:'140',dataId:'device',sortable:true}
    ]

    if(usersettings.CatDevicesList&&usersettings.CatDevicesList.cols){
        for(let i=0;i<usersettings.CatDevicesList.cols.length;i++){
            const idx=cols.findIndex(el=>el.dataId===usersettings.CatDevicesList.cols[i])
            if(idx!==-1) cols[idx].hiden=true
        }
    }

    const filterData=[ //+
        {caption:localestr('Назва'),dataId:'name',typeVal:'text'},
        {caption:localestr('Тип пристрою'),dataId:'device',typeVal:'selDeviceType'}
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter,currentCol:undefined})
        setGlData({needFocus:1})
        tblPos(0)
    }

    const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        if(!showAFilter) setWndData({...wndData,filter:undefined,showAFilter})
        else setWndData({...wndData,showAFilter})
    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            //const newItem={id:item.id,name:item.name,fio:item.fio,marked:item.marked}
            const newItem={...item,device:selDeviceType.find(x => x.value === item.device),prnicon:{name:'icon',src:icon+'#catPrint'+item.device+(item.marked==='1'?'Del':'')},Printer:{id:item.Printer_id,name:''}}
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol(newItem)
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const setHidenCols=(data)=>{
        if(data){
            const new_data=data.filter(el=>el.hiden).map(el=>el.dataId)
            setSettings({CatDevicesList:{cols:new_data}})
        } else {
            inputCols(cols,setHidenCols)
        }
    }

    const newScrPrt=()=>{tabNew(type+'3_edit',localestr('Екранний принтер')+' *',{device:3,changed:true})}
    const newRawPrt=()=>{tabNew(type+'3_edit',localestr('Принтер')+' RawBT *',{device:2,changed:true})}
    const newIRRO=()=>{tabNew(type+'4_edit',localestr('ПРРО')+' *',{device:4,loadkey:true,loadlic:true,changed:true})}
    const newTRRO=()=>{tabNew(type+'5_edit',localestr('РРО')+' *',{device:5,changed:true})}

    const editItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(wndData.currentCol.device && parseInt(wndData.currentCol.device.value)===2) tabNew(type+'3_edit',localestr('Принтер')+' RawBT '+toText(wndData.currentCol['name']),{...wndData.currentCol,device:2})
            else if(wndData.currentCol.device && parseInt(wndData.currentCol.device.value)===3) tabNew(type+'3_edit',localestr('Екранний принтер')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol,device:3})
            else if(wndData.currentCol.device && parseInt(wndData.currentCol.device.value)===4) tabNew(type+'4_edit',localestr('ПРРО')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol,device:4})
            else if(wndData.currentCol.device && parseInt(wndData.currentCol.device.value)===5) tabNew(type+'5_edit',localestr('РРО')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol,device:5})
        }
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            //console.log(wndData.currentCol)
            if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else if(wndData.currentCol.device && parseInt(wndData.currentCol.device.value)===2) tabNew(type+'3_edit',localestr('Принтер')+' RawBT '+toText(wndData.currentCol['name']),{...wndData.currentCol,device:2})
            else if(wndData.currentCol.device && parseInt(wndData.currentCol.device.value)===3) tabNew(type+'3_edit',localestr('Екранний принтер')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol,device:3})
            else if(wndData.currentCol.device && parseInt(wndData.currentCol.device.value)===4) addTWnd(localestr('ПРРО')+' '+toText(wndData.currentCol['name']),type+'4_viev',undefined,{...wndData.currentCol,device:4},undefined,false,{width:'260px',height:'unset'},false)
            else if(wndData.currentCol.device && parseInt(wndData.currentCol.device.value)===5) addTWnd(localestr('РРО')+' '+toText(wndData.currentCol['name']),type+'5_viev',undefined,{...wndData.currentCol,device:5},undefined,false,{width:'260px',height:'unset'},false)
        }
    }
            
    const removeItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            let newData={status:'rem',key:type,data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='0'?'1':'0')}}
            saveData(newData,()=>{})
        }
    }
    
    const setCol=(currentCol)=>{
        //const list=wndData.list
        //const sorting=wndData.sorting
        setWndData({...wndData,currentCol})
        setGlData({needFocus:0})
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        if(showFilter || fltr===undefined) setWndData({...wndData,showFilter,filter})
        else{
            setWndData({...wndData,showFilter,filter,currentCol:undefined})
            setGlData({needFocus:1})
            tblPos(0)
        }
    }

    const clrCatalog=(noQuestions)=>{
        if(noQuestions){
            let newData={status:'clr',key:type}
            saveData(newData,()=>{})
        }
        else msg(localestr('Буде видалено позначені елементи без\nможливості відновлення! Продовжити?'),localestr('Попередження'),[{caption:'OK',action:()=>{clrCatalog(true)}},{caption:localestr('Відміна'),action:()=>{}}])
    }

    const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            tabNew('repObjHistory',localestr('Історія змін')+' '+toText(wndData.currentCol['name']),{object:{...wndData.currentCol,type:type}},true)
        }
    }
        
    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newIRRO()
        //else if(key==='F9') copyItem()
        //else if(key==='Escape') cancelEdit()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
    }

    const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        if (typeof Data === 'undefined') getData(type)
        else if (typeof wndData!=='undefined' && wndData!=='' && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
    // eslint-disable-next-line 
    },[Data])

    useEffect(() => {
        if (typeof Data === 'undefined') return//getData('catUsers')
        else if (typeof wndData==='undefined' || wndData==='') sortList('name','asc')
    // eslint-disable-next-line 
    },[wndData])

    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+

    const newData=[
        {name:localestr('Принтер ')+'RawBT',action:newRawPrt},
        {name:localestr('Екранний принтер'),action:newScrPrt},
        {name:localestr('Фіскальний реєстратор'),action:newIRRO},
        {name:localestr('Тестовий реєстратор'),action:newTRRO},
    ]
    const menuData=[
        {name:localestr('Налаштування таблиці'),icon:'#b953',action:setHidenCols},
        {name:localestr('Автофільтр'),icon:'#b955',action:showHideFilter},
        {name:localestr('Друк списку'),icon:'#b503',action:()=>{window.print()}},
        {name:localestr('Історія змін'),icon:'#b505',action:objHistory},
        {name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{updateData(type)}},
    ]
    if(choice) menuData.splice(2,3)
    
    return(
        <>
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)',width:'100%'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            //onClick={newItem}
            //onKeyUp={(e)=>{if(e.key === 'Enter') newItem()}}
            ><Menu data={newData} left={true}><img className='toolBarIcon' src={icon+'#addBut'} alt={localestr('Додати')} /></Menu></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={()=>{editItem()}}
            onKeyDown={(e)=>{if(e.key === 'Enter') editItem()}}><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')}
            onClick={()=>{removeItem()}}
            onKeyDown={(e)=>{if(e.key === 'Enter') removeItem()}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Фільтр')}  
            onClick={()=>{filter()}}
            onKeyDown={(e)=>{if(e.key === 'Enter') filter()}}><img src={icon+'#filtBut'} alt={localestr('Фільтр')} /></div>
            <div style={{flexGrow:'10'}}></div>

            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={editClick} keyHandle={anyKey} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default CatDevicesList